var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-link dropdown-item text-primary",on:{"click":_vm.setData}},[_vm._t("default",function(){return [_vm._v("Ver Histórico de Alteração")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }